// extracted by mini-css-extract-plugin
export default {"yearViewWrapper":"CalendarView_yearViewWrapper__XANig"};